var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoiceMail = function SvgVoiceMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".voice-mail_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 5,
    className: "voice-mail_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12,
    r: 5,
    className: "voice-mail_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17h-13",
    className: "voice-mail_svg__a"
  })));
};
export default SvgVoiceMail;